import { render, staticRenderFns } from "./Params.vue?vue&type=template&id=5f647384&lang=pug&"
import script from "./Params.vue?vue&type=script&lang=ts&"
export * from "./Params.vue?vue&type=script&lang=ts&"
import style0 from "./Params.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports